<template>
  <div>
    <section class="p-box">
      <ValidationObserver ref="form" tag="form">
        <div class="p-box__body">
          <div class="p-box">
            <header class="p-box__header">
              <h2>{{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.header') }}</h2>
            </header>
            <div class="p-box__body">
              <Info>
                {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.info') }}
              </Info>
              <div class="selectedStores">
                <i18n-t keypath="pages.CompaniesLocationStoresBulkUpdateWithGmb.selectedStoresCount" tag="p">
                  <span class="selectedStores__link u-colorPrimary" @click="selectedStoresModal = true">{{ $tc('labels.storesCount', storeIdCount) }}</span>
                </i18n-t>
              </div>
              <div class="gmbLocationItems">
                <div class="gmbLocationItems__header">
                  <input id="syncAll" v-model="syncAll" type="checkbox" class="c-checkbox__input" @change="toggleAllCheck($event.target.checked)">
                  <label class="c-checkbox__label" :for="'syncAll'">
                    {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncAll') }}
                  </label>
                </div>
                <ul class="c-checkbox">
                  <li class="c-checkbox__item">
                    <input id="syncStoreName" v-model="syncStoreName" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncStoreName'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncStoreName') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncAddress" v-model="syncAddress" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncAddress'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncAddress') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncPhone" v-model="syncPhone" :value="true" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncPhone'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncPhone') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncStoreDescription" v-model="syncStoreDescription" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncStoreDescription'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncStoreDescription') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncRegularHour" v-model="syncRegularHour" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncRegularHour'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncRegularHour') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncSpecialHour" v-model="syncSpecialHour" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncSpecialHour'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncSpecialHour') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncPaymentMethod" v-model="syncPaymentMethod" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncPaymentMethod'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncPaymentMethod') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncSiteSetting" v-model="syncSiteSetting" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncSiteSetting'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncSiteSetting') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncCategory" v-model="syncCategory" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncCategory'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncCategory') }}
                    </label>
                  </li>
                  <li class="c-checkbox__item">
                    <input id="syncOpenInfo" v-model="syncOpenInfo" type="checkbox" class="c-checkbox__input" @change="toggleCheck()">
                    <label class="c-checkbox__label" :for="'syncOpenInfo'">
                      {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.checkBoxes.syncOpenInfo') }}
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="p-box__footer">
          <div class="c-button c-button--right">
            <router-link :to="{ name: 'CompaniesLocationStores', params: { company_uuid: companyUuid }}" class="c-button__item c-button__item--outline-cancel">
              {{ $t('labels.cancel') }}
            </router-link>
            <button :disabled="!isCheckSyncItem" class="c-button__item c-button__item--primary" @click.prevent="confirmationModal = true">
              {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.submit') }}
            </button>
          </div>
        </div>
      </ValidationObserver>
    </section>
    <StoresModal
      v-if="selectedStoresModal"
      :header-label="$t('pages.CompaniesLocationStoresBulkUpdateWithGmb.selectedStores')"
      :store-names="selectedStores.map(s => s.attributes.name)"
      @close="selectedStoresModal = false"
    />
    <ConfirmationModal
      v-if="confirmationModal"
      @submit="onSubmit()"
      @close="confirmationModal = false"
    >
      <p>
        {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.confirmation1') }}
      </p>
      <p>
        {{ $t('pages.CompaniesLocationStoresBulkUpdateWithGmb.confirmation2') }}
      </p>
    </ConfirmationModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Info from '../../../../components/Info'
import StoresModal from '../../../../components/Modals/StoresModal'
import ConfirmationModal from '../../../../components/Modals/ConfirmationModal'

export default {
  name: 'CompaniesLocationStoresBulkUpdateWithGmb',
  components: {
    Info,
    StoresModal,
    ConfirmationModal,
  },
  data() {
    return {
      selectedStoresModal: false,
      confirmationModal: false,
      syncStoreName: false,
      syncAddress: false,
      syncPhone: false,
      syncStoreDescription: false,
      syncRegularHour: false,
      syncSpecialHour: false,
      syncPaymentMethod: false,
      syncSiteSetting: false,
      syncCategory: false,
      syncOpenInfo: false,
      syncAll: false,
    }
  },
  computed: {
    ...mapState({
      stores: state => state.companiesStores.data?.data,
      selectedStoreIds: state => state.companiesBulkUpdateWithGmbs.storeIds
    }),
    ...mapGetters({
      storeIdCount: 'companiesBulkUpdateWithGmbs/storeIdCount',
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    selectedStores() {
      return this.stores.filter(s => this.selectedStoreIds.includes(s.id))
    },
    query() {
      return {
        sync_store_name: this.syncStoreName,
        sync_address: this.syncAddress,
        sync_phone: this.syncPhone,
        sync_store_description: this.syncStoreDescription,
        sync_regular_hour: this.syncRegularHour,
        sync_special_hour: this.syncSpecialHour,
        sync_payment_method: this.syncPaymentMethod,
        sync_site_setting: this.syncSiteSetting,
        sync_category: this.syncCategory,
        sync_open_info: this.syncOpenInfo,
      }
    },
    isCheckSyncItem() {
      return this.syncStoreName ||
        this.syncAddress ||
        this.syncPhone ||
        this.syncStoreDescription ||
        this.syncRegularHour ||
        this.syncSpecialHour ||
        this.syncPaymentMethod ||
        this.syncSiteSetting ||
        this.syncCategory ||
        this.syncOpenInfo
    },
    isCheckedAllItems() {
      return this.syncStoreName &&
        this.syncAddress &&
        this.syncPhone &&
        this.syncStoreDescription &&
        this.syncRegularHour &&
        this.syncSpecialHour &&
        this.syncPaymentMethod &&
        this.syncSiteSetting &&
        this.syncCategory &&
        this.syncOpenInfo
    }
  },
  created() {
    if (!this.$route.params.storeIds || this.$route.params.storeIds.length === 0) this.$router.push({ name: 'CompaniesLocationStores' })

    this.setStoreIds(this.$route.params.storeIds)
  },
  methods: {
    ...mapActions({
      setStoreIds: 'companiesBulkUpdateWithGmbs/setStoreIds',
      bulkUpdateWithGmb: 'companiesBulkUpdateWithGmbs/bulkUpdateWithGmb',
    }),
    toggleAllCheck(value) {
      this.syncStoreName = value
      this.syncAddress = value
      this.syncPhone = value
      this.syncStoreDescription = value
      this.syncRegularHour = value
      this.syncSpecialHour = value
      this.syncPaymentMethod = value
      this.syncSiteSetting = value
      this.syncCategory = value
      this.syncOpenInfo = value
    },
    toggleCheck() {
      this.syncAll = this.isCheckedAllItems
    },
    async onSubmit() {
      this.confirmationModal = false
      this.bulkUpdateWithGmb({ companyUuid: this.companyUuid, query: this.query })
        .then(() => {
          this.$router.push({ name: 'CompaniesLocationStores' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.selectedStores {
  margin-bottom: 16px;
  &__link {
    text-decoration: none;
    cursor: pointer;
  }
}
.gmbLocationItems {
  $root: #{&};
  border: 1px solid $color-base-c;
  border-radius: 4px;
  box-shadow: 0 0 0 rgba(63, 63, 68, .05);
  background: #FFF;
  display: flex;

  &__header {
    width: 30%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 24px;
    border-bottom: 1px solid $color-base-c;
    background: #f5f6f9;
    font-weight: bold;
  }

  &__body {
    width: 80%;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
}
.c-checkbox {
  margin: 12px 6px -8px;

  &__item {
    padding: 12px 18px;
    margin:  -6px 0 14px;
  }
}
</style>
